import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["appearance", "className", "density", "isCombined", "isInline", "size", "shape"];
import * as React from 'react';
import cn from 'classnames';
import { ControlSizeType, ControlAppearanceType, isDefined } from '../../../library/index';
import { tagClasses } from './tag';
import { Pane } from '../../pane';
export var TagGroup = function TagGroup(props) {
  var appearance = props.appearance,
    className = props.className,
    density = props.density,
    isCombined = props.isCombined,
    isInline = props.isInline,
    size = props.size,
    shape = props.shape,
    paneProps = _objectWithoutProperties(props, _excluded);
  var classNames = cn(tagClasses.GROUP, _defineProperty(_defineProperty(_defineProperty({
    '-sm': props.size === ControlSizeType.SMALL,
    '-lg': props.size === ControlSizeType.LARGE,
    '-combined': props.isCombined,
    '-inline': props.isInline
  }, "-".concat(props.density), isDefined(props.density)), "-".concat(props.appearance), isDefined(props.appearance)), "-".concat(props.shape), isDefined(props.shape)), props.className);
  return React.createElement(Pane, _extends({
    className: classNames
  }, paneProps));
};
TagGroup.displayName = 'TagGroup';
TagGroup.defaultProps = {
  appearance: ControlAppearanceType.MINIMAL,
  isCombined: false,
  isInline: false
};